import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TiposImoveisPorDestinacaoResponse } from '../model/integracao';
import { MatIcon } from '@angular/material/icon';

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CORRETORES, Corretor } from '../model/corretorLista';
import { BuscaAvancadaFilter } from '../model/busca-avancada-filter.model';
import { UtilService } from '../services/util.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { BuscaService } from '../services/busca.service';
import { Subject } from 'rxjs/internal/Subject';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { ModalService } from '../services/modal.service';
import { ModalOpcaoContratoComponent } from './modal-opcao-contrato/modal-opcao-contrato.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ImovelResponseDto } from '../dto/imovel-response.dto';
import { EnderecoImovelPipe } from "../pipes/endereco-imovel.pipe";
import { DeveExibirAtributoPipe } from "../pipes/deve-exibir-atributo";
import { groupBy } from '../util';
import { LojasComponent } from "../components/lojas/lojas.component";
import { TitleComponent } from "../components/title/title.component";
import { CorretoresGalleryComponent } from "./corretores-gallery/corretores-gallery.component";
import { FinanciamentoCardComponent } from "./financiamento-card/financiamento-card.component";
import { BairrosGalleryComponent } from "./bairros-gallery/bairros-gallery.component";
import { CorretorService } from '../services/corretor.service';
import { EmpreendimentosComponent } from "../components/empreendimentos/empreendimentos.component";
import { SwiperImagensComponent } from '../components/swiper-imagens/swiper-imagens.component';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';

@Component({
   selector: 'app-home',
   standalone: true,
   imports: [
      CommonModule,
      FormsModule,
      MatIcon,
      MatInputModule,
      MatAutocompleteModule,
      MatOptionModule,
      MatDialogModule,
      EnderecoImovelPipe,
      DeveExibirAtributoPipe,
      LojasComponent,
      TitleComponent,
      CorretoresGalleryComponent,
      FinanciamentoCardComponent,
      BairrosGalleryComponent,
      EmpreendimentosComponent,
      SwiperImagensComponent,
      MatAutocompleteModule,
      MatInputModule,
      MatChipsModule
   ],
   templateUrl: './home.component.html',
   styleUrl: './home.component.scss'
   // changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {
   public subTipos: { name: string; checked: boolean }[] = [];
   public tips: string[] = [];
   private searchSubject = new Subject<string>();

   public imoveisDestaqueLocacaoGrouped: ImovelResponseDto[][] = [];
   public imoveisDestaqueVendaGrouped: ImovelResponseDto[][] = [];
   public imoveisDestaqueInvestirGrouped: ImovelResponseDto[][] = [];

   // 🔹 Estado da Aplicação
   mobile: boolean = true;
   isCodigo: boolean = false;
   selectedCompra: number = 2;
   mostrarOpcao: boolean = false;
   textoBotao: string = 'Tipo de Imóvel';

   // 🔹 Filtros e Seleções
   searchCod: string = '';
   codigoTipo: string = '';
   searchTextTip: string;

   // 🔹 Dropdowns
   dropdownOpenTip = false;

   // 🔹 Listas de Seleção
   selectedTipos: string[] = [];
   selectedTiposNomes: string[] = [];

   destinacoes: TiposImoveisPorDestinacaoResponse[] = [];

   public seletecedTipos: number[] = [];
   private subscriptions: Subscription[] = [];

   bairros: string[];
   searchTextBairro: string = '';
   selectedBairros: string[] = [];
   selectedBairrosNomes: string[] = [];
   filteredBairros: any[] = [];
   BairrosDisponiveis: any[] = [];
   dropdownOpenBairro = false;

   constructor(
      private utilService: UtilService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private router: Router,
      private buscaService: BuscaService,
      private modalService: ModalService,
      private corretorService: CorretorService
   ) { }

   ngOnDestroy() {
      this.subscriptions.forEach((sub) => sub.unsubscribe());
   }

   async ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
         this.checkMobile();
         if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkMobile.bind(this));
         }

         // 🔹 Garante que o scroll acontece depois da renderização
         setTimeout(() => {
            // window.scrollTo(0, 0);
         });

         // 🔹 Faz o scroll ao navegar entre páginas
         this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
               setTimeout(() => {
                  window.scrollTo(0, 0);
               });
            }
         });
      }

      this.filteredBairros = this.utilService.fetchBairros().map((nome, index) => ({ codigo: index, nome }));
    this.BairrosDisponiveis = this.utilService
         .fetchBairros()
         .map((bairro, index) => ({ nome: bairro, codigo: index }));

      this.buscarDestaqueLocacao();
      this.buscarDestaqueVenda();
      this.buscarDestaqueInvestimento();

      await this.corretorService.getCorretores();
      await this.corretorService.getCorretorByCodigo(55);

      this.subTipos = this.utilService.fetchSubtipos().map((subtipo: string) => ({
         name: subtipo,
         checked: false
      }));

      const sub2 = this.searchSubject
         .pipe(
            debounceTime(300),
            distinctUntilChanged(),
            filter((keywords) => keywords && keywords.trim().length >= 3),
            switchMap((keywords) => this.buscaService.fetchTips({ contrato: this.selectedCompra, keywords }))
         )
         .subscribe({
            next: (result: string[]) => {
               this.tips = result;
            },
            error: () => (this.tips = [])
         });

      this.subscriptions.push(sub2);
   }

   displayFn(tip: string): string {
      return tip ? tip : '';
   }

   onSearchChange(value: string): void {
      if (value.length < 3) {
         this.tips = [];
      }
      this.searchSubject.next(value);
   }

   // ✅ Verifica se o dispositivo é mobile
   checkMobile() {
      if (typeof window !== 'undefined') {
         this.mobile = window.innerWidth < 935;
      }
   }

   // ✅ Alterna entre busca por código ou bairro
   checkCod() {
      this.isCodigo = !this.isCodigo;
      this.searchCod = this.isCodigo ? '' : this.searchCod;
   }

   // ✅ Alterna exibição do dropdown de Tipos de Imóveis
   toggleDropdownTip(event: Event) {
      event.stopPropagation(); // Impede que o clique feche imediatamente o dropdown
      this.dropdownOpenTip = !this.dropdownOpenTip;
      if (this.dropdownOpenTip) {
      }
   }

   // ✅ Gerencia seleção múltipla de tipos de imóveis
   toggleSelectionTip(index: number) {
      this.subTipos[index].checked = !this.subTipos[index].checked;
      this.selectedTiposNomes = this.subTipos.filter((s) => s.checked).map((s) => s.name);
   }

   // ==============================
   // 🔹 BUSCA POR BAIRROS
   // ==============================

   // ==============================
   // 🔹 GESTÃO DE DROPDOWNS
   // ==============================
   opShow = true;

   // ✅ Alterna a exibição de opções
   abrirOpcao() {
      this.mostrarOpcao = !this.mostrarOpcao;
      this.opShow = !this.mostrarOpcao;
   }

   // ✅ Atualiza o texto do botão ao selecionar uma opção
   atualizarTextoBotao(opcao: string): void {
      this.textoBotao = opcao;
      this.mostrarOpcao = false;
   }

   adjustCarouselSize(): void {
      if (typeof document !== 'undefined') {
         const carrosselIds = [
            'carouselImoveis',
            'carouselImoveisPrincipais',
            'carouselImoveisDestaque',
            'carouselImoveisApto',
            'carouselCorretores',
            'carouselUnidades'
         ];

         carrosselIds.forEach((id) => {
            const carrossel = document.querySelector(`#${id}`) as HTMLElement;
            if (carrossel) {
               const cards = carrossel.querySelectorAll('.card-destaque');
               if (cards.length > 0) {
                  const cardWidth = cards[0].getBoundingClientRect().width;
                  carrossel.style.scrollSnapType = 'x mandatory';
                  carrossel.style.scrollPaddingLeft = `${cardWidth * 0.1}px`; // Ajusta espaço inicial

                  // Configura a rotação automática
                  let index = 0;
                  setInterval(() => { }, 3000);
               }
            }
         });
      }
   }

   private handleError(error: any): void {
      if (error.status === 400) {
         console.error('Erro de validação: Verifique os dados enviados.', error.message);
      } else if (error.status === 500) {
         console.error('Erro interno no servidor. Tente novamente mais tarde.', error.message);
      } else {
         console.error('Erro inesperado:', error.message);
      }
   }

   limitarFrase(frase: string, limite: number): string {
      frase = frase.replace(/-/g, ' ');
      frase = frase.charAt(0).toUpperCase() + frase.slice(1);

      if (frase.length > limite) {
         return frase.substring(0, limite - 3) + '...';
      } else {
         return frase;
      }
   }

   async buscarDestaqueVenda() {
      const sub = this.fetchDestaque('destaque-venda').subscribe({
         next: (data) => {
            const items = data?.items ?? [];
            const tamanhoGrupo = this.mobile ? data?.items.length : 4;
            this.imoveisDestaqueVendaGrouped = groupBy(items, tamanhoGrupo);
         },
         error: () => console.error('Erro em buscarDestaqueLancamento')
      });
      this.subscriptions.push(sub);
   }

   async buscarDestaqueInvestimento() {
      const sub = this.fetchDestaque('destaque-investimento').subscribe({
         next: (data) => {
            const items = data?.items ?? [];
            const tamanhoGrupo = this.mobile ? data?.items.length : 4;
            this.imoveisDestaqueInvestirGrouped = groupBy(items, tamanhoGrupo);
         },
         error: () => console.error('Erro em buscarDestaqueInvestimento')
      });
      this.subscriptions.push(sub);
   }

   async buscarDestaqueLocacao() {
      const sub = this.fetchDestaque('destaque-locacao').subscribe({
         next: (data) => {
            const items = data?.items ?? [];
            const tamanhoGrupo = this.mobile ? data?.items.length : 4;
            this.imoveisDestaqueLocacaoGrouped = groupBy(items, this.mobile ? tamanhoGrupo : 4);
         },
         error: () => console.error('Erro em buscarDestaqueLocacao')
      });
      this.subscriptions.push(sub);
   }

   private fetchDestaque(tag: string) {
      return this.buscaService.fetch({
         page: 1,
         pageSize: 30,
         sortby: 'd_date',
         tags: [tag]
      });
   }

   acessaImoveis() {
      let filtro: BuscaAvancadaFilter = {};

      if (this.searchCod) {
         const codigos: string[] = this.searchCod
            .split(',')
            .map((i) => i.trim())
            .filter((i) => i !== '');

         const temSomenteNumeros = codigos.every((codigo) => /^\d+$/.test(codigo));
         if (codigos.length >= 1 && temSomenteNumeros) {
            filtro.codigos = codigos;
         } else {
            filtro.contrato = this.selectedCompra === 2 ? 'Compra' : 'Locação';
            filtro.sortby = 'd_date';
            filtro.keywords = this.searchCod ?? null;
            filtro.subtipo = this.selectedTiposNomes ?? null;
         }
      } else {
         filtro.contrato = this.selectedCompra === 2 ? 'Compra' : 'Locação';
         filtro.sortby = 'd_date';
         filtro.keywords = this.searchTextTip ?? null;
         filtro.subtipo = this.selectedTiposNomes ?? null;

         if (this.selectedBairrosNomes.length > 0) {
            filtro.bairros = this.selectedBairrosNomes;
         }
      }

      this.router.navigate(['/busca-avancada'], {
         queryParams: { ...filtro },
         queryParamsHandling: 'replace'
      });
   }

   acessaImoveisPorBairro(bairro: string) {
      this.router.navigate(['/busca-avancada', {}]);
   }

   abreImovel(imovelSlug: any): void {
      // this.router.navigate(['/imovel', imovelSlug]);
      const url = this.router.serializeUrl(this.router.createUrlTree(['/imovel', imovelSlug]));
      window.open(url, '_blank'); // Abre em uma nova aba
   }

   acessaCorretor(id: number): void {
      this.router.navigate(['/corretor/', id.toString()]);
   }

   acessaContato() {
      this.router.navigate(['/contato']);
   }

   openModal(tipo: string) {
      this.modalService.open(ModalOpcaoContratoComponent, {
         tipo
      });
   }
   onFocus() {
      // Mostra todos os bairros ao focar
      this.filteredBairros = this.bairros;
   }

   // ✅ Remover bairro ao clicar no "X"
   removeBairro(nome: string) {
      const index = this.selectedBairrosNomes.indexOf(nome);
      if (index !== -1) {
         this.selectedBairros.splice(index, 1);
         this.selectedBairrosNomes.splice(index, 1);
      }
   }
   keepDropdownOpen(event: Event) {
      event.stopPropagation(); // Impede que o clique feche o dropdown
      this.dropdownOpenBairro = true;
   }

   // ✅ Remover o último bairro ao pressionar Backspace
   removeLastBairro() {
      if (this.searchTextBairro === "" && this.selectedBairros.length > 0) {
         this.selectedBairros.pop();
         this.selectedBairrosNomes.pop();
      }
   }

   // ✅ Exibir sugestões ao digitar
   filterOptionsBairro() {
      const search = this.searchTextBairro.toLowerCase();
      this.filteredBairros = this.BairrosDisponiveis.filter((bairro) =>
         `${bairro.nome}`.toLowerCase().includes(search)
      );
   }

   // ✅ Adicionar bairro ao pressionar ENTER ou vírgula
   addBairroFromInput() {
      const bairroEncontrado = this.BairrosDisponiveis.find(b =>
         b.nome.toLowerCase() === this.searchTextBairro.trim().toLowerCase()
      );

      if (bairroEncontrado && !this.isBairroSelected(bairroEncontrado.nome)) {
         this.selectedBairros.push(bairroEncontrado.nome);
         this.selectedBairrosNomes.push(bairroEncontrado.nome);
      }

      this.searchTextBairro = ""; // Limpar input após adição
      this.filterOptionsBairro(); // Atualizar lista filtrada
   }

   // ✅ Verifica se o bairro já está selecionado
   isBairroSelected(nome: string): boolean {
      return this.selectedBairrosNomes.includes(nome);
   }

   // ✅ Selecionar bairro ao clicar no dropdown
   toggleSelectionBairro(bairro: any) {
      const index = this.selectedBairrosNomes.indexOf(bairro.nome);

      if (index === -1) {
         // Adiciona bairro
         this.selectedBairrosNomes.push(bairro.nome);
      } else {
         // Remove bairro
         this.selectedBairrosNomes.splice(index, 1);
      }

      this.searchTextBairro = ""; // Limpar input após seleção
   }
   // ✅ Alterna exibição do dropdown de bairros
   toggleDropdownBairro(event: Event) {
      event.stopPropagation();
      this.dropdownOpenBairro = !this.dropdownOpenBairro;
   }


   // ✅ Fecha dropdowns ao clicar fora
   @HostListener('document:click', ['$event'])
   fecharDropdownFora(event: Event) {
      const targetElement = event.target as HTMLElement;

      // Referências ao modal
      const modal = document.getElementById("modalFiltro");

      // 🔹 Obtém todos os botões que devem abrir o modal
      const botoesAbrir = document.querySelectorAll(".btn-small-content");

      // ✅ Verifica se o clique foi em um dos botões do modal
      if (Array.from(botoesAbrir).some(botao => botao === targetElement || botao.contains(targetElement))) {
         if (modal) modal.style.display = "block";
         return; // Evita que o próximo bloco feche o modal imediatamente
      }

      // ✅ Fecha o modal se o clique foi fora dele
      if (modal && !modal.contains(targetElement)) {
         modal.style.display = "none";
      }

      // ✅ Fecha os dropdowns caso o clique tenha sido fora deles
      if (!targetElement.closest('.select-wrapper')) {
         this.dropdownOpenBairro = false;
         this.dropdownOpenTip = false;
      }
   }

   clickAceitaPermuta() {
      let filtro: BuscaAvancadaFilter = {};
       filtro.contrato = 'Compra';
        filtro.sortby = 'd_date';
        filtro.permuta = 'true';
        filtro.page = 1;
        filtro.pageSize = 24;
        filtro.tags = ['feirao']


      this.router.navigate(['/busca-avancada'], {
         queryParams: { ...filtro },
         queryParamsHandling: 'replace'
      });

   }

    clickImoveisComDesconto() {
      let filtro: BuscaAvancadaFilter = {};
       filtro.contrato = 'Compra';
        filtro.sortby = 'd_date';
        filtro.page = 1;
        filtro.pageSize = 24;
        filtro.tags = ['feirao']


      this.router.navigate(['/busca-avancada'], {
         queryParams: { ...filtro },
         queryParamsHandling: 'replace'
      });

   } 

   clickEntradaFacilitada() {
      let filtro: BuscaAvancadaFilter = {};
       filtro.contrato = 'Compra';
        filtro.sortby = 'd_date';
        filtro.page = 1;
        filtro.pageSize = 24;
        filtro.tags = ['feirao', 'entrada-facilitada']


      this.router.navigate(['/busca-avancada'], {
         queryParams: { ...filtro },
         queryParamsHandling: 'replace'
      });

   }
   
   hasFeirao(imovel: ImovelResponseDto) {
         return imovel && imovel.tags && imovel.tags.includes('feirao');
   }

   handleLogoClick() {
       this.modalService.open(ModalOpcaoContratoComponent, {
         tipo: 'IMOVEIS_FEIRAO'
      });
   }
}
